import React, { useContext, useState, useEffect } from 'react'
import AuthContext from '../../../../product/context/auth/authContext'
//import Popup from '../../../../custom/components/organisms/Popup'
import Popup from '../../../../product/components/organisms/FullScreenPopup'
import { Button } from '@mui/material'
import AlertContext from '../../../../product/context/alert/alertContext'
import { useFormik } from 'formik'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../../../product/components/atoms/SecondaryButton'
import { mapData } from '../../../../product/common/components'

import * as Yup from 'yup'
import {
    dateFormatFront,
    dateTimeFormatFunction,
    capitalize,
    currencyFormat,
} from '../../../../custom/common/components'
import InvoiceContext from '../../../../product/context/invoice/invoiceContext'
import ReturnContext from '../../../../product/context/return/returnContext'
import Loaders from '../../../../product/components/molecules/Loaders'

function RefundInvoice(props) {
    const invoiceContext = useContext(InvoiceContext)
    const { single_invoice, getSingleInvoice, all_invoices } = invoiceContext

    const returnContext = useContext(ReturnContext)
    const { refundInvoiceStatus, responseStatus: responseStatusReturn } =
        returnContext

    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)

    let [invoiceDetails, setInvoiceDetails] = useState({
        invoiceProducts: [],
        cartValues: {},
        appointmentDetail: {},
        locationDetail: {},
        invoiceTransactions: [],
        invoiceAddress: [],
        invoiceUser: [],
    })

    const validationTracking = Yup.object({
        invoice_id: Yup.string().required('Required!'),
        user_id: Yup.string().required('Required!'),
        amount: Yup.number().moreThan(0, 'Required!').required('Required!'),
        reason: Yup.string().required('Required!'),
        internal_reason: Yup.string().required('Required!'),
        project_id: Yup.array().required('Required!'),
    })

    const addressformik = useFormik({
        initialValues: {
            invoice_id: '',
            user_id: '',
            project_id: [],
            amount: '',
            reason: '',
            internal_reason: '',
            cart: 1,
        },
        validationSchema: validationTracking,
        onSubmit: (values) => {
            console.log('validationTracking', values)
            refundInvoiceStatus(values)
        },
    })

    console.log('addressformik', addressformik.errors)
    useEffect(() => {
        console.log('data', data)
        if (data.popup && data.data.id) {
            addressformik.values.invoice_id = data.data.id
            addressformik.values.user_id = data.data.user_id
            setIsLoading(true)
            getSingleInvoice(addressformik.values)
        }
    }, [data])

    useEffect(() => {
        console.log('single_invoice', single_invoice, data)
        if (
            single_invoice &&
            (data.status === 'edit' || data.status === 'view')
        ) {
            setInvoiceDetails({
                invoiceProducts: single_invoice.invoicerecords.length
                    ? single_invoice.invoicerecords
                    : [],
                cartValues: single_invoice.cartvalues,
                appointmentDetail: single_invoice.appointmentrecord,
                locationDetail: single_invoice.locationrecord,
                invoiceAddress: single_invoice.invoiceaddressrecord,
                invoiceUser: single_invoice.invoiceuserrecord,
                invoiceTransactions: single_invoice.transactionrecords,
            })
            setIsLoading(false)
        }
    }, [single_invoice])

    const refundData = {
        formik: addressformik,
        data: [
            {
                label: 'Item Returned',
                placeholder: 'Enter Item Returned',
                type: 'multiselect',
                class: 'col-12',
                options: invoiceDetails.invoiceProducts
                    .filter((cat) => cat.returned !== 1)
                    .map((maincat) => {
                        let categoryChanged = {}
                        categoryChanged.show = maincat.projects_title
                        categoryChanged.value = maincat.projects_id
                        return categoryChanged
                    }),
                name: 'project_id',
            },
            {
                label: 'Enter Amount',
                name: 'amount',
                type: 'number',
                placeholder: `Enter amount`,
                class: 'col-sm-6 col-12',
                autoFocus: false,
            },
            {
                label: 'Reason',
                placeholder: 'Enter reason',
                class: 'col-sm-6 col-12',
                type: 'select',
                options: [
                    { value: 'duplicate', show: 'Duplicate' },
                    { value: 'fraudulent', show: 'Fraudalent' },
                    {
                        value: 'requested_by_customer',
                        show: 'Requested by customer',
                    },
                ],
                name: 'reason',
            },
            {
                label: 'Internal Reason *',
                type: 'text',
                placeholder: 'Enter your Internal Reason',
                class: 'col-sm-6 col-12',
                name: 'internal_reason',
            },
        ],
    }

    useEffect(() => {
        if (responseStatusReturn) {
            if (responseStatusReturn.from === 'refundInvoiceStatus') {
                if (responseStatusReturn.status === 'success') {
                    addressformik.resetForm()
                    toggleFullScreenPopup(false)
                }
            }
        }
    }, [responseStatusReturn])
    return (
        <Popup
            open={data.popup}
            size="md"
            handleClose={() => toggleFullScreenPopup(false)}
            modaltitle="Refund Invoice"
        >
            <div className="trackingInfo">
                {/* {console.log(trackingInfo, 'tracking info')} */}
                {invoiceDetails ? (
                    <>
                        {' '}
                        {invoiceDetails.invoiceTransactions.length ? (
                            <>
                                <h4 className="invoiceSubTitle">
                                    {'Transaction Details'}
                                </h4>
                                <div className="transDet d-flex justify-content-between flex-wrap">
                                    <>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    {/* <th scope="col">S.No</th> */}
                                                    <th scope="col">
                                                        {'Transaction ID'}
                                                    </th>
                                                    <th scope="col">
                                                        {'Paid on'}
                                                    </th>
                                                    <th scope="col">
                                                        {'Method'}
                                                    </th>
                                                    <th scope="col">
                                                        {'Amount'}
                                                    </th>
                                                    <th scope="col">
                                                        {'Status'}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {invoiceDetails.invoiceTransactions.map(
                                                    (data, index) => (
                                                        <tr key={index}>
                                                            <td
                                                                data-title={
                                                                    'Transaction ID'
                                                                }
                                                            >
                                                                {data.trans_id
                                                                    ? `# ${data.trans_id}`
                                                                    : '-'}
                                                            </td>
                                                            <td
                                                                data-title={
                                                                    'Paid On'
                                                                }
                                                            >
                                                                {dateTimeFormatFunction(
                                                                    data.created_at
                                                                )}
                                                            </td>
                                                            <td
                                                                data-title={
                                                                    'Card'
                                                                }
                                                            >
                                                                {capitalize(
                                                                    data.payment_method
                                                                )}
                                                            </td>
                                                            <td
                                                                data-title={
                                                                    'Amount'
                                                                }
                                                            >
                                                                {currencyFormat(
                                                                    data.amount
                                                                )}
                                                            </td>
                                                            <td
                                                                data-title={
                                                                    'Payment Status'
                                                                }
                                                                style={{
                                                                    color:
                                                                        data.status ===
                                                                        'success'
                                                                            ? 'green'
                                                                            : 'red',
                                                                }}
                                                            >
                                                                {capitalize(
                                                                    data.status
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </>
                                </div>
                            </>
                        ) : null}
                        {isLoading ? (
                            <Loaders isLoading={isLoading} />
                        ) : (
                            <form
                                onSubmit={addressformik.handleSubmit}
                                autoComplete="nofill"
                            >
                                <div className="row">{mapData(refundData)}</div>
                                <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                    <SecondaryButton
                                        label="Cancel"
                                        btnSize="mr-3"
                                        onClick={() =>
                                            toggleFullScreenPopup(false)
                                        }
                                    />
                                    <PrimaryButton
                                        type="submit"
                                        label="Submit"
                                    />
                                </div>
                            </form>
                        )}
                    </>
                ) : (
                    <div> Invoice Details Not Fetched </div>
                )}
            </div>
        </Popup>
    )
}

export default RefundInvoice
